import { useTranslation } from 'react-i18next'

import { useContentOverflow } from '../../../../hooks'
import { Field } from '../../../Field'
import { FloatingTooltip } from '../../../Floating'
import Text from '../../../Text'

import { QA_NAME_LISTING_FORM_FLAT_FACTS } from './RentalPortalListingFlatFieldWithFacts.constants'
import { getListingFlatFactsText } from './RentalPortalListingFlatFieldWithFacts.utils'

import * as styles from './RentalPortalListingFlatFieldWithFacts.module.css'

function RentalPortalListingFlatFieldWithFacts({
  FieldComponent = Field,
  children,
  flat,
  ...fieldProps
}) {
  const { t } = useTranslation()

  const { overflow, setContentOverflowRef } = useContentOverflow()

  const factsText = getListingFlatFactsText({ flat, t })

  return (
    <FieldComponent {...fieldProps} fieldInputClassName={styles.input}>
      {children}
      {factsText ? (
        <FloatingTooltip content={factsText} disabled={!overflow}>
          <Text
            isSecondary
            className={styles.facts}
            qaName={QA_NAME_LISTING_FORM_FLAT_FACTS}
            ref={setContentOverflowRef}
          >
            {factsText}
          </Text>
        </FloatingTooltip>
      ) : null}
    </FieldComponent>
  )
}

export default RentalPortalListingFlatFieldWithFacts
